import SourceComponent from './SourceComponent';

export default SourceComponent;
